import classnames from 'classnames';

import Cached from './Cached';

const CircleSpinner = ({ className }) => (
  <Cached className={classnames(className, 'animated-rotate')} />
);

export default CircleSpinner;
